import { ArrowRightIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements';

export type OldPlanUserProps = {
  className?: string;
};

export const OldPlanUserAdvise = ({ className }: OldPlanUserProps) => {
  const { t } = useTranslation();

  const onActionClick = () => window.location.assign('/account/products');

  return (
    <div
      className={`max-w-6xl p-8 mt-5 bg-yellow-100 text-yellow-900 border border-yellow-200 m-auto ${className}`}
    >
      <h3 className="md__payments__container--h3">{t('OldPlanUserAdvise.title')}</h3>
      <p className="mt-5">{t('OldPlanUserAdvise.description')}</p>
      <p className="font-black">{t('OldPlanUserAdvise.claimText')}</p>
      <Button
        className="m-auto mt-10 lg:mx-0 py-2 lg:py-4 text-xs lg:text-sm w-[400px] rounded-full"
        variant="primary"
        size="free"
        type="button"
        title={t('RequestAccountHero.actionButton')}
        onClick={onActionClick}
        endIcon={<ArrowRightIcon className="h-5 w-5 text-white mr-6" aria-hidden="true" />}
      >
        {t('OldPlanUserAdvise.actionButton')}
      </Button>
    </div>
  );
};
